export default __webpack_public_path__ + "static/Nox4-d6df7cee79c9b640d63d584f531d6e73.png";